import primaryLinks from './messages/primaryLinks';
import siteLinks from './messages/siteLinks';
import socialLinks from './messages/socialLinks';
import legalLinks from './messages/legalLinks';
import sitemapLinks from './messages/sitemapLinks';
import appLink from './messages/appLink';

export { primaryLinks, siteLinks, socialLinks, sitemapLinks, appLink, legalLinks };
